import { render } from "./ProductViewedList.vue?vue&type=template&id=729c2fb6&scoped=true"
import script from "./ProductViewedList.vue?vue&type=script&lang=js"
export * from "./ProductViewedList.vue?vue&type=script&lang=js"

import "./ProductViewedList.vue?vue&type=style&index=0&id=729c2fb6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-729c2fb6"]])

export default __exports__